
import EUsersTypes from '../../enums/EUsersTypes'
import { displayMessage } from "../../helpers/messages"
import { DateTime } from 'luxon'
import dayjs from 'dayjs';


const dateFormat = 'dd/LL/yyyy'

export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 80

    },
    {
        field: 'full_name',
        headerName: displayMessage('FIRST_NAME'),
        valueGetter: (params) => params.row.full_name || '',
        width: 180

    },
    {
        field: 'email',
        headerName: displayMessage('EMAIL'),
        valueGetter: (params) => params.row.email || '',
        width: 200

    },
    {
        field: 'client_name',
        headerName: displayMessage('CLIENT'),
        valueGetter: (params) => params.row?.client?.name || '',
        width: 150

    },
    {
        field: 'user_type',
        headerName: displayMessage('TYPE'),
        valueGetter: (params) => params.row?.type_description || '',
        width: 150

    },
    {
        field: 'plan_expired',
        headerName: 'Validade',
        valueFormatter: (params) => params.value ? dayjs(params.value)?.format('DD/MM/YYYY') : "Sem limite",
        width: 120
    },
    {
        field: 'is_plan_active',
        headerName: 'Plano',
        width: 100,
        renderCell: (params) => {
            const isActive = params.value;
            const daysLeft = params.row.days_until_expiration;
            
            if (params.row.plan_expired === null) {
                return <span style={{ color: '#52c41a', fontWeight: 500 }}>✓ Ativo</span>;
            }
            
            if (isActive) {
                if (daysLeft !== null && daysLeft <= 7) {
                    return <span style={{ color: '#faad14', fontWeight: 500 }}>⚠ {daysLeft}d</span>;
                }
                return <span style={{ color: '#52c41a', fontWeight: 500 }}>✓ Ativo</span>;
            }
            
            return <span style={{ color: '#ff4d4f', fontWeight: 500 }}>✗ Expirado</span>;
        }
    },
]